<template>
  <div class="contact">
    <div class="breadcrumb">
      <router-link class="breadcrumb-item" to="/">Accueil</router-link><span class="breadcrumb-separator">></span><span class="breadcrumb-current-item">Contact</span>
    </div>
    <div class="central-container">
      <h1>Contactez-nous</h1>
      <div class="validation-messages" v-show="formSuccess || formError">
          <span class="success" v-if="formSuccess">Votre message a bien été envoyé, nous vous recontacterons dans les plus brefs délais</span>
          <span class="error" v-if="formError">Une erreur s'est produite, veuillez réessayer plus tard</span>
      </div>
      <div class="columns-container">
        <div class="form-container column">
          <form @submit="sendMessage">
            <div class="form-group">
              <label for="lastname">Nom</label>
              <input
                  type="text"
                  class="form-control"
                  id="lastname"
                  name="lastname"
                  v-model="form.lastname"
              />
            </div>
            <div class="form-group">
              <label for="firstname">Prénom</label>
              <input
                  type="text"
                  class="form-control"
                  id="firstname"
                  name="firstname"
                  v-model="form.firstname"
              />
            </div>
            <div class="form-group">
              <label for="email">E-mail</label>
              <input type="email" class="form-control" id="email" name="email" v-model="form.email" />
            </div>
            <div class="form-group">
              <label for="phone">Téléphone</label>
              <input
                  type="text"
                  class="form-control"
                  id="phone"
                  name="phone"
                  v-model="form.phone"
              />
            </div>
            <div class="form-group">
              <label for="message">Votre message</label>
              <textarea
                  class="form-control"
                  id="message"
                  v-model="form.message"
                  name="message"
                  aria-describedby="messageHelp"
              ></textarea>
            </div>

            <button type="submit" class="btn btn-primary">Envoyer</button>
          </form>
        </div>
        <div class="address-container column">
          <div class="data">
            <div class="address picto">
              <span>1 Av. du Professeur Jean Rouxel</span>
              <br>
              <span class="bold">Carquefou</span>
              <br>
              <span>44300</span>
            </div>
            <div class="phone picto">
              <span>02 85 52 33 06</span>
            </div>
            <div class="mail picto">
              <a href="mailto:contact@flaxeo.com">contact@flaxeo.com</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="ajax-loader" v-show="loader">
      <span></span>
    </div>
  </div>
</template>

<script>
import { BACKEND_API } from "@/config/api";
import { API_ROUTE } from "@/config/api";
import Metatags from "@/script/metatags.js";

export default {
  name: "Contact",
  data: () => {
    return {
      formSuccess: false,
      formError: false,
      loader: false,
      form: {
        lastname: '',
        firstname: '',
        email: '',
        phone: '',
        message: ''
      },
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    Metatags.update(
        'Flaxeo : nous contacter',
        'Vous ne trouvez pas la réponse à votre question ? Flaxeo est à votre disposition via ce formulaire de contact.'
    );
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/enterprise.js?render=6LecThMcAAAAACkYz1jZwh1ZGzpK9go70iPMc8Q4')
    document.head.appendChild(recaptchaScript);
  },
  methods: {
    sendMessage(e) {
      e.preventDefault();
      let self = this;
      window.grecaptcha.enterprise.ready(function() {
        // eslint-disable-next-line no-unused-vars
        window.grecaptcha.enterprise.execute('6LecThMcAAAAACkYz1jZwh1ZGzpK9go70iPMc8Q4', {action: 'login'}).then(function(token) {
          self.loader = true;
          let currentObj = self;
          currentObj.formError = false;
          currentObj.formSuccess = false;

          BACKEND_API.post(API_ROUTE.CONTACT, {
            lastname: currentObj.form.lastname,
            firstname: currentObj.form.firstname,
            email: currentObj.form.email,
            phone: currentObj.form.phone,
            message: currentObj.form.message
          })
          .then(function (response) {
            currentObj.loader = false;
            if (response.data[0].success === true) {
              currentObj.formSuccess = true;
              currentObj.form = {
                lastname: '',
                firstname: '',
                email: '',
                phone: '',
                message: ''
              };
            } else {
              currentObj.formError = true;
            }
            window.scrollTo(0, 0);
          })
          .catch(function (error) {
            currentObj.loader = false;
            currentObj.formError = true;
            currentObj.output = error;
            window.scrollTo(0, 0);
          });
        });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

@keyframes spinner {
  to {transform: rotate(360deg);}
}

.ajax-loader {
  background: #ffffff;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  z-index: 10;
  opacity: 0.7;

  span {
    background: url("../assets/loader.png");
    width: 53px;
    height: 50px;
    left: 50%;
    top: 50%;
    position: fixed;
    animation: spinner 1.6s linear infinite;
  }
}

.contact {
  padding-top: 30px;
  max-width: 1365px;
  margin: 0 auto;
  font-size: 0.9em;
  position: relative;

  &::before {
    background-image: url("../assets/x.png");
    background-size: 440px;
    background-repeat: no-repeat;
    content: " ";
    width: calc(371px - (1243px - 100%) / 2);
    height: 406px;
    position: absolute;
    right: 0;
    top: 254px;
  }

  .breadcrumb {
    max-width: 1081px;
    margin: 0 auto;
  }
  .central-container {
    margin: 40px auto 0;
    text-align: left;
    max-width: 1081px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    h1 {
      color: $second-bg-color;
      font-size: 2rem;
      text-align: left;
      text-transform: uppercase;
      margin-bottom: 60px;
      margin-top: unset;
      background-color: white;
    }
    .validation-messages {
      span {
        width: 100%;
        padding: 20px;
        color: #fff;
        display: inline-block;
        margin-bottom: 20px;

        &.success {
          background: #54B7BC;
        }

        &.error {
          background: red;
        }
      }
    }
    .columns-container {
      display: flex;
      align-items: center;
      flex-direction: row;
      width: 100%;

      .form-container {
        width: 50%;
        .form-group {
          display: flex;
          flex-direction: column;
          margin-bottom: 10px;
          padding: 0 5px;
          border-bottom: 5px solid white;

          label {
            color: #707070;
            font-weight: 600;
          }
          input,
          textarea {
            padding: 5px 0;
            border: unset;
            border-bottom: 2px solid #707070;
            box-shadow: unset;
            outline: unset;
          }
          textarea {
            resize: vertical;
            min-height: 100px;
          }
        }
      }
      .address-container {
        width: 50%;

        .data {
          width: 150px;
          margin: 0 auto;
          padding-left: 170px;

          .bold {
            font-weight: bold;
          }
          .picto {
            padding: 15px 0;
            color: $second-text-color;
            position: relative;
            z-index: 1;

            &:before {
              content: " ";
              position: absolute;
              margin-left: -40px;
            }
          }
          .address {
            &:before {
              background: url("../assets/localisation_picto.png");
              margin-top: 14px;
              height: 32px;
              width: 24px;
            }
          }
          .phone {
            &:before {
              background: url("../assets/telephone_picto.png");
              height: 26px;
              width: 26px;
            }
          }
          .mail {
            &:before {
              background: url("../assets/mail_bleu_picto.png");
              width: 30px;
              height: 21px;
            }
            a {
              text-decoration: none;
              color: $second-text-color;
              cursor: pointer;
            }
          }
        }
      }
    }
  }

  .btn-primary {
    background: $main-text-color;
    float: right;
    padding: 11px 30px;
    font-size: 1rem;
    text-transform: initial;
    border-radius: 15px;
    font-weight: normal;
    border: unset;
    color: white;
    cursor: pointer;
  }

  .custom-select:focus,
  .form-control-file:focus,
  .form-control:focus {
    border-color: $main-text-color;
    box-shadow: inset 0 -2px 0 -1px $second-bg-color;
  }

  .contact-text {
    padding: 30px 0;
  }

  .map-infos {
    img {
      &[lazy="loaded"] {
        width: 100%;
      }
    }
  }
}
@media screen and (max-width: 1081px) {
  .contact {
    padding: 30px 20px 0;
  }
}
@media screen and (max-width: 870px) {
  .contact {
    &::before {
      content: unset;
    }
    .central-container {
      .columns-container {
        display: flex;
        flex-direction: column;
        align-items: center;

        .form-container {
          width: 100%;
        }
        .address-container {
          width: 100%;

          .data {
            padding-left: 40px;
            padding-top: 30px;

            .picto {
              background-color: white;
            }
          }
        }
      }
    }
  }
}
</style>
